import React from 'react';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

function Contact() {
  return (
    <main style={{ paddingTop: 'var(--navbar-height)' }}>
      <ContactForm />
      <Footer />
    </main>
  );
}

export default Contact;
